import React from 'react'
import { assetsClients } from '../../utils/assets';
import styles from "../../pages/pages.module.scss";
import "../../layout/styles.scss"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TrustedSection = () => {

  const  sliderSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2 }
      }
    ]
  };

  return (
    <>
      <div className="container mb-5">
        <div className={`${styles.clientsheading}`}>
          <h3>
            <span>Trusted</span>by businesses that operate on
          </h3>
          <Slider {...sliderSettings} className= "mt-4 slick-track-wrapper">
            {assetsClients.map((img, index) => (
              <div key={index} className="align-items-center d-flex text-center">
                <img
                  src={img.src}
                  alt={`Client ${index + 1}`}
                  className={`img-fluid ${styles.logoswrapper} align-self-center mx-auto my-auto`}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  )
}

export default TrustedSection;